import { Component, OnInit, ElementRef, ViewChild, HostListener, Input, OnDestroy } from '@angular/core';
import { Direction } from '../../../types/directions';
import { CmxLayoutService } from '../../../services/cmx-layout.service';
import { IConsolesMenu } from '../../../types/consoles';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cmx-header-employee-menu',
  templateUrl: './cmx-header-employee-menu.component.html',
  styleUrls: ['./cmx-header-employee-menu.component.scss'],
})
export class CmxHeaderEmployeeMenuComponent implements OnInit, OnDestroy {
  @Input()
  console: IConsolesMenu;
  @ViewChild('consolesMenuRef', { static: true })
  consolesMenuRef: ElementRef;
  direction: Direction = 'ltr';
  isConsolesMenuOpen = false;

  private subscriptions: Subscription[] = [];

  constructor(public layout: CmxLayoutService) {}

  ngOnInit() {
    this.subscriptions.push(this.layout.direction.subscribe((value) => (this.direction = value)));
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.consolesMenuRef && !this.consolesMenuRef.nativeElement.contains(event.target)) {
      if (this.isConsolesMenuOpen) {
        this.isConsolesMenuOpen = false;
      }
    }
  }

  toggleConsolesMenu() {
    if (this.console && this.console.subItems && this.console.subItems.length !== 0) {
      this.isConsolesMenuOpen = !this.isConsolesMenuOpen;
    } else {
      this.onItemClick(this.console.id);
    }
  }

  onItemClick(id: string | number) {
    this.isConsolesMenuOpen = false;
    this.layout.consolesMenuClick.emit(id);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
